// collapsible.ts — collapsible heading sections in the rendered preview.
//
// Extracted from markdown-renderer.js (Stage A of the monolith split). Pure
// DOM: wraps each h2–h6 (and the content up to the next same-or-higher
// heading) in a <details>/<summary>, honouring the collapse-marker injected by
// the preprocess pass. H1 is left alone (note title). No imports, no state.

/** `container` is the rendered-preview container. */
export function setupCollapsibleHeadings(container: any): void {
  const headingTags = new Set(['H1', 'H2', 'H3', 'H4', 'H5', 'H6']);
  const headingLevel = (el: any): number => parseInt(el.tagName[1], 10);

  function nodeHeadingLevel(node: any): number | null {
    if (node.nodeType !== Node.ELEMENT_NODE) return null;
    if (headingTags.has(node.tagName)) return headingLevel(node);
    if (node.tagName === 'DETAILS') {
      const h = node.querySelector(
        'summary > h1, summary > h2, summary > h3, summary > h4, summary > h5, summary > h6'
      );
      return h ? headingLevel(h) : null;
    }
    return null;
  }

  // H1 is never collapsible — it acts as the note title
  const headings = [...container.querySelectorAll('h2,h3,h4,h5,h6')].reverse();

  headings.forEach((heading) => {
    const level = headingLevel(heading);
    const details = document.createElement('details');
    details.open = !heading.querySelector('.collapse-marker');
    const summary = document.createElement('summary');
    summary.appendChild(heading.cloneNode(true));
    details.appendChild(summary);

    const siblings = [];
    let next = heading.nextSibling;
    while (next) {
      const after = next.nextSibling;
      const sibLevel = nodeHeadingLevel(next);
      if (sibLevel !== null && sibLevel <= level) break;
      siblings.push(next);
      next = after;
    }
    siblings.forEach((s) => {
      details.appendChild(s);
    });
    heading.replaceWith(details);
  });
}
